const colors = {
  primary: {
    color1: '#307343',
    color2: '#55B971',
    color3: '#B7E1C3',
    color4: '#D4F6De',
    color5: '#F0FFF4',
  },
  secondary: {
    // color1: '#192F59',
    color1: '#EAEAF2',
    color2: '#6D6BA2',
    color3: '#80A0DB',
    color4: '#F8F8F8',
  },
  grey: {
    color1: '#333333',
    color2: '#4F4F4F',
    color3: '#828282',
    color4: '#BDBDBD',
    color5: '#E0E0E0',
    color6: '#F2F2F2',
    color7: '#383838',
    color8: '#FAFAFA' /* Alternate BG || neutral 10 */,
  },
  error: '#EB5757',
  warning: '#F2994A',
  emphasis: '#F2C94C',
  white: '#FFFFFF',
  sidebarBgColor: '#121131',
  sidebarBgBlackColor: '#010101',
};

const neutrals = {
  text1: '#333333',
  text2: '#4F4F4F',
  placeholder: '#828282',
  disabled: '#BDBDBD',
  hover: '#E0E0E0',
  divider: '#F2F2F2',
  color3: '#6E6E6E',
};

const headings = {
  h1: {
    fontFamily: 'Mulish-Medium',
    fontSize: 66,
    lineHeight: '78px',
    letterSpacing: '0em',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h2: {
    fontFamily: 'Mulish-Bold',
    fontSize: 24,
    lineHeight: '49px',
    letterSpacing: '0em',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h3: {
    fontFamily: 'Mulish-Medium',
    lineHeight: '28px',
    letterSpacing: '0em',
    fontSize: 24,
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h4: {
    fontFamily: 'Mulish-Regular',
    letterSpacing: '0em',
    fontSize: 24,
    lineHeight: '28px',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h5: {
    fontFamily: 'Mulish-Medium',
    fontStyle: 'normal',
    letterSpacing: '0em',
    fontSize: 18,
    lineHeight: '21px',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h6: {
    fontFamily: 'Mulish-Regular',
    letterSpacing: '0em',
    fontSize: 18,
    lineHeight: '21px',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h7: {
    fontFamily: 'Mulish-Bold',
    fontStyle: 'normal',
    letterSpacing: '0em',
    fontSize: 16,
    lineHeight: '16px',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h8: {
    fontFamily: 'Mulish-Medium',
    letterSpacing: '0em',
    fontSize: 16,
    lineHeight: '18px',
    textAlign: 'left',
    color: '#000',
  },
  h9: {
    fontFamily: 'Mulish-Medium',
    fontStyle: 'normal',
    letterSpacing: 'normal',
    fontSize: 14,
    lineHeight: 'normal',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h10: {
    fontFamily: 'Mulish-Regular',
    letterSpacing: '0em',
    fontSize: 14,
    lineHeight: '16px',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h11: {
    fontFamily: 'Mulish-Bold',
    letterSpacing: '0em',
    fontSize: 14,
    lineHeight: '16px',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h12: {
    fontFamily: 'Mulish-SemiBold',
    letterSpacing: '0em',
    fontSize: 14,
    lineHeight: '14px',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h13: {
    fontFamily: 'Mulish-Regular',
    letterSpacing: '0em',
    fontSize: 14,
    lineHeight: '14px',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h14: {
    fontFamily: 'Mulish-Medium',
    letterSpacing: '0em',
    fontSize: 14,
    lineHeight: '14px',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h15: {
    fontFamily: 'Mulish-Regular',
    letterSpacing: '0em',
    fontSize: 14,
    lineHeight: '14px',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h16: {
    fontFamily: 'Mulish-Medium',
    letterSpacing: '0em',
    fontSize: 14,
    lineHeight: '12px',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  h17: {
    fontFamily: 'Mulish-Regular',
    letterSpacing: '0em',
    fontSize: 14,
    lineHeight: '12px',
    textAlign: 'left',
    color: colors.grey.color7,
    textTransform: 'uppercase',
  },
  h18: {
    fontFamily: 'Mulish-Regular',
    letterSpacing: '0em',
    fontSize: 14,
    lineHeight: '12px',
    textAlign: 'left',
    color: '#000000',
  },
  h19: {
    fontFamily: 'Mulish-Regular',
    letterSpacing: '0em',
    fontSize: 14,
    lineHeight: '17px',
    textAlign: 'left',
  },
  sidebar: {
    fontFamily: 'Mulish-SemiBold',
    letterSpacing: '0.32px',
    fontSize: 16,
    // fontWeight: 600,
    lineHeight: 'normal',
    textAlign: 'left',
    color: colors.grey.color7,
  },
  footer: {
    fontFamily: 'Mulish-Bold',
    fontSize: 16,
    textAlign: 'center',
    color: colors.grey.color7,
  },
  pageHeading: {
    fontFamily: 'Mulish-Bold',
    fontSize: 20,
    fontWeight: 'bold',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 'normal',
    letterSpacing: 'normal',
    textAlign: 'left',
    color: '#0e0d25',
  },
};

const gradients = {
  primary: {
    bg1: 'linear-gradient(180deg, #307343 0%, #55B971 100%)',
  },
  secondary: {
    bg1: 'linear-gradient(180deg, #192F59 0%, #4070C9 100%)',
  },
};

const vars = {
  colors,
  gradients,
  neutrals,
  headings,
};

export default vars;
